import { render } from "./ParentTable.vue?vue&type=template&id=e6b6634e&scoped=true"
import script from "./ParentTable.vue?vue&type=script&lang=js"
export * from "./ParentTable.vue?vue&type=script&lang=js"

import "./ParentTable.vue?vue&type=style&index=0&id=e6b6634e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b6634e"]])

export default __exports__